import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerCategories = [categories[0], categories[1], categories[2], categories[3], categories[9]];

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 py-14 md:py-20 px-6 md:px-12 mx-4 md:mx-6 mb-4 md:mb-6 rounded-2xl">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-2xl md:text-3xl font-semibold text-white block mb-6">
              yoybuy<span className="text-accent-400">.baby</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              Ваш надёжный помощник в мире покупок. YOYBUY Spreadsheet — экономьте время и деньги.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Категории</h4>
            <ul className="space-y-3">
              {footerCategories.map((cat) => (
                <li key={cat.nameEn}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-white transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/yoybuy-sheet-guide-2026"
                  className="text-sm text-accent-400 hover:text-accent-300 transition-colors"
                >
                  Полное руководство
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Социальные сети</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="flex items-center gap-2.5 text-sm text-foreground-400 hover:text-white transition-colors">
                  <i className="ri-instagram-line text-base"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center gap-2.5 text-sm text-foreground-400 hover:text-white transition-colors">
                  <i className="ri-youtube-line text-base"></i>
                  YouTube
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center gap-2.5 text-sm text-foreground-400 hover:text-white transition-colors">
                  <i className="ri-facebook-line text-base"></i>
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Подпишитесь на обновления</h4>
            <div className="flex">
              <input
                type="email"
                placeholder="Ваш email"
                className="flex-1 bg-foreground-800 border border-foreground-700 rounded-l-full px-4 py-2.5 text-sm text-white placeholder-foreground-500 outline-none focus:border-accent-500 transition-colors"
              />
              <button className="bg-accent-500 hover:bg-accent-600 text-background-50 rounded-r-full px-4 py-2.5 transition-colors">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 pt-8 border-t border-foreground-800">
          <p className="text-center text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} yoybuy.baby — Все права защищены. | Powered by{' '}
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-accent-500 hover:text-accent-400 transition-colors">
              YOYBUY Spreadsheet
            </a>
          </p>
          <div className="mt-6 overflow-hidden">
            <p className="text-6xl md:text-8xl font-heading font-bold text-foreground-800/30 text-center whitespace-nowrap select-none">
              yoybuy.baby
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}